import React, { useEffect, useState } from 'react'
import API from '../../../../services/API'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import VisibilityIcon from '@mui/icons-material/Visibility'
import DeleteIcon from '@mui/icons-material/Delete'
import SmallModal from '../../../../components/Modals/SmallModal'
import EMPTemplateViewer from './EMPTemplateViewer'
const EMPTemplates = () => {
  const [templates, setTemplates] = useState([])
  const [viewTemplate, setViewTemplate] = useState(null)
  const [confirmDelete, setConfirmDelete] = useState(false)

  useEffect(() => {
    API.get('/admin/emptemplates').then((res) => {
      if (res.status === 200) {
        setTemplates(res.data)
      }
    })
  }, [])

  const handleDelete = () => {
    API.delete(`/admin/emptemplate/${confirmDelete._id}`).then((res) => {
      if (res.status === 200) {
        setTemplates((prev) => prev.filter((x) => x._id !== confirmDelete._id))
        setConfirmDelete(null)
      }
    })
  }

  return (
    <Stack gap={1}>
      <Typography variant="title2">EMP Templates</Typography>
      {templates.length === 0 && (
        <Alert severity="info">No templates created yet</Alert>
      )}
      <Stack gap={1} divider={<Divider />}>
        {templates.map((x) => (
          <Stack
            direction="row"
            justifyContent="space-between"
            padding={1}
            border="solid 2px"
            borderColor="anBlue.main"
            borderRadius={1}
            alignItems="center"
            component={Paper}
            elevation={1}
            key={x._id}
          >
            <Typography>{x.title}</Typography>
            <ButtonGroup>
              <IconButton onClick={() => setViewTemplate(x)}>
                <VisibilityIcon color="anMainBlue" />
              </IconButton>
              <IconButton onClick={() => setConfirmDelete(x)}>
                <DeleteIcon color="error" />
              </IconButton>
            </ButtonGroup>
          </Stack>
        ))}
      </Stack>
      <SmallModal open={!!confirmDelete}>
        <Stack gap={1}>
          <Typography variant="title3">
            Are you sure you want to delete{' '}
            <strong>{confirmDelete?.title}</strong>?
          </Typography>
          <ButtonGroup>
            <Button color="success" onClick={handleDelete}>
              Yes - Delete
            </Button>
            <Button color="error" onClick={() => setConfirmDelete(null)}>
              Cancel
            </Button>
          </ButtonGroup>
        </Stack>
      </SmallModal>
      <EMPTemplateViewer
        viewTemplate={viewTemplate}
        setViewTemplate={setViewTemplate}
      />
    </Stack>
  )
}

export default EMPTemplates
